<template>
  <div>
    <el-descriptions class="margin-top" title="Efetivar pagamento" :column="2" border>
      <el-descriptions-item>
        <template slot="label">
          <i class="el-icon-user"></i>
          {{ $t('cpf/cnpj') }}
        </template>
        {{ complement.federalid }}
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label">
          <i class="el-icon-location-outline"></i>
          {{ $t('nome') }}
        </template>
        {{ complement.name }}
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label">
          <i class="el-icon-mobile-phone"></i>
          {{ $t('telefone') }}
        </template>
        {{ complement.phone }}
      </el-descriptions-item>
      <el-descriptions-item v-if="payment.type !== 'pix'">
        <template slot="label">
          <i class="el-icon-location-outline"></i>
          {{ $t('cep') }}
        </template>
        <el-tag>{{ complement.cep }}</el-tag>
      </el-descriptions-item>
      <el-descriptions-item v-else>
        <template slot="label">
          <i class="el-icon-location-outline"></i>
          {{ $t('email') }}
        </template>
        <el-tag>{{ complement.mail }}</el-tag>
      </el-descriptions-item>
      <el-descriptions-item :span="2" v-if="payment.type !== 'pix'">
        <template slot="label">
          <i class="el-icon-office-building"></i>
          {{ $t('endereco') }}
        </template>
        {{ complement.address }}, {{ complement.neighborhood }}, {{ complement.city }}-{{ complement.state }}
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label">
          <i class="el-icon-money"></i>
          {{ $t('pagamento-com') }}
        </template>
        <el-tag type="success">
          {{ payment.type == 'pix'
            ? 'PIX'
            : payment.type == 'credit'
              ? 'Cartão de crédito'
              : payment.type == 'debit'
                ? "Cartão de débito"
                : "Boleto bancário"
          }}</el-tag>
      </el-descriptions-item>
    </el-descriptions>
  </div>
</template>

<script>
import { UserService } from "@/services/users/user.services";
export default {
  name: 'PaymentCompleted',
  props: {
    "complement": Object,
    "payment": Object,
  },
  data() {
    return {
      ruleForm: {
        federalid: '',
        name: '',
        cep: "",
        address: "",
        city: "",
        state: "",
        neighborhood: "",
        number: "",
        phone: "",
        extent: "",
      }
    }
  },
  methods: {
    get() {
      return this.ruleForm;
    },
    test(tag, message) {
      const vm = this;
      if (!vm.ruleForm[tag]) {
        this.$message({
          type: "error",
          message: message,
        });
        vm.$refs[tag].$el.children[0].focus();
        return false;
      }
      return true;
    },
    validate() {
      return this.test('federalid', "CPF/CNPJ é obrigatório!")
        ? this.test('name', "Nome é obrigatório!")
          ? this.test('cep', "CEP é obrigatório!")
            ? this.test('address', "Endereço é obrigatório!")
              ? this.test('city', "Cidade é obrigatório!")
                ? this.test('state', "Estado é obrigatório!")
                  ? this.test('neighborhood', "Bairro é obrigatório!")
                    ? this.test('phone', "Telefone é obrigatório!")
                    : false
                  : false
                : false
              : false
            : false
          : false
        : false;
    }
  },
  mounted() {
    const vm = this;
    const loading = vm.$loading(vm.$options.loading);

    UserService.me()
      .then((user) => {
        console.log('user', user);
        vm.ruleForm.phone = user.customer ? user.customer.phone : '';
        vm.ruleForm.name = user.username;
        vm.ruleForm.federalid = user.customer ? user.customer.federalid : '';
        vm.ruleForm.cep = user.customer ? user.customer.zipcode.zipcode : '';
        vm.ruleForm.address = user.customer ? user.customer.address | user.customer.zipcode.address : '';
        vm.ruleForm.city = user.customer ? user.customer.city | user.customer.zipcode.city : '';
        vm.ruleForm.state = user.customer ? user.customer.state | user.customer.zipcode.state : '';
        vm.ruleForm.neighborhood = user.customer ? user.customer.neighborhood | user.customer.zipcode.neighborhood : '';
        vm.ruleForm.number = user.customer ? user.customer.number : '';
        vm.ruleForm.extent = user.customer ? user.customer.extent : '';
      })
      .catch((error) => {
        this.$message({
          type: "error",
          message: error,
        });
      })
      .finally(() => loading.close());

  }
}
</script>
